import React from 'react'
import { Paper } from '@material-ui/core/index'
import {
    collectionSecurityCodeTypes,
    getObjectKey,
    shippingMethods,
    orderStateTypes,
    orderTypes,
    courierParcelEventTypeIds,
    entryTypeIds,
    eventTypes,
} from '../../../server/shared'
import { strings } from '../../../localization/strings'
import moment from 'moment'

class Component extends React.Component {
    isSecurityCodePresent = (collectionSecurityCode) => {
        return (
            !!collectionSecurityCode &&
            !!collectionSecurityCode.type &&
            collectionSecurityCode.type !==
                collectionSecurityCodeTypes.noSecurityCodePresent
        )
    }

    isSignaturePresent = (signature) => {
        return !!signature && signature !== ''
    }

    isReverseLogistic = (tracking) => {
        return tracking.orderTypeId === orderTypes.reverseLogistic
    }

    getPickupDate = (tracking) => {
        if (tracking && tracking.events && tracking.events.length > 0) {
            let events = tracking.events.sort((x, y) =>
                x.timeStamp > y.timeStamp ? 1 : -1
            )
            let parcelPickupEvent = events.find(
                (x) =>
                    (x.entryTypeId === entryTypeIds.reservationEvent &&
                        x.typeId === eventTypes.reservationCollected) ||
                    (x.entryTypeId === entryTypeIds.courierEvent &&
                        x.typeId === courierParcelEventTypeIds.parcelPickUp)
            )
            if (parcelPickupEvent && parcelPickupEvent.timeStamp) {
                return moment(parcelPickupEvent.timeStamp).format(
                    'DD-MM-YYYY HH:mm'
                )
            }
        }
        return null
    }

    render() {
        var tracking = this.props.tracking
        if (!tracking) return null
        var isReverseLogistic = this.isReverseLogistic(tracking)

        var date = tracking.date
            ? moment(tracking.date).format('DD-MM-YYYY HH:mm')
            : null
        var pickupDate = this.getPickupDate(tracking)

        var show =
            (tracking.orderStateId === orderStateTypes.customerPickup ||
                (isReverseLogistic && pickupDate)) &&
            (tracking.shippingMethodId === shippingMethods.standard ||
                tracking.shippingMethodId === shippingMethods.shipToAddress)

        if (
            !tracking.collectionSecurityCode &&
            !tracking.signature &&
            (!date || !tracking.address) &&
            (!isReverseLogistic || !pickupDate)
        )
            show = false

        if (!show) return null

        return (
            <Paper
                elevation={3}
                style={{
                    padding: 10,
                    maxWidth: 600,
                    width: '90%',
                    margin: 'auto',
                    whiteSpace: 'pre-line',
                    marginTop: 10,
                    marginBottom: 10,
                }}
            >
                {!tracking.address || !date ? null : (
                    <h3>
                        {tracking.shippingMethodId === shippingMethods.standard
                            ? isReverseLogistic
                                ? strings.trackingStandardMessageText
                                      .replace('{{address}}', tracking.address)
                                      .replace('{{date}}', pickupDate)
                                : strings.trackingStandardMessageText
                                      .replace('{{address}}', tracking.address)
                                      .replace('{{date}}', date)
                            : null}
                        {tracking.shippingMethodId ===
                        shippingMethods.shipToAddress
                            ? isReverseLogistic
                                ? strings.trackingShipToAddressReverserLogisticMessageText
                                      .replace('{{address}}', tracking.address)
                                      .replace('{{date}}', pickupDate)
                                : strings.trackingShipToAddressMessageText
                                      .replace('{{address}}', tracking.address)
                                      .replace('{{date}}', date)
                            : null}
                        <br />
                        {isReverseLogistic &&
                        tracking.orderStateId ===
                            orderStateTypes.courierDelivered
                            ? strings.trackingDeliveredToCourierReverserLogisticMessageText
                                  .replace('{{address}}', tracking.address)
                                  .replace('{{date}}', date)
                            : null}
                    </h3>
                )}

                {this.isSecurityCodePresent(tracking.collectionSecurityCode) ||
                this.isSignaturePresent(tracking.signature) ? (
                    <h3 key={1}>
                        <strong>
                            {isReverseLogistic
                                ? strings.trackingReverseLogisticMessageText
                                : tracking.shippingMethodId ===
                                  shippingMethods.standard
                                ? strings.trackingCollectedByMessageText
                                : strings.trackingDeliveredToMessageText}
                        </strong>
                        {this.isSecurityCodePresent(
                            tracking.collectionSecurityCode
                        )
                            ? strings[
                                  'collectionSecurityCodeTypes_' +
                                      getObjectKey(
                                          collectionSecurityCodeTypes,
                                          tracking.collectionSecurityCode.type
                                      )
                              ] +
                              ' ' +
                              tracking.collectionSecurityCode.code
                            : null}
                    </h3>
                ) : null}

                {this.isSignaturePresent(tracking.signature) ? (
                    <div style={{ textAlign: 'center' }}>
                        <img
                            id="img"
                            src={'data:image/png;base64,' + tracking.signature}
                            alt={strings.trackingSignatureImageAlt}
                            style={{ maxWidth: '90%', height: 150 }}
                        />
                    </div>
                ) : null}
            </Paper>
        )
    }
}

export default Component
